import { NoteBlock } from "../block";

export interface WebSocketBlock extends NoteBlock {
  type: "omega/query-omega/page/block/websocket/WebSocketBlock";
  "websocket-id": string;
}

export const isWebSocketBlock = (block: NoteBlock): block is WebSocketBlock => {
  return (block as WebSocketBlock)["websocket-id"] !== undefined;
};
